import * as React from "react";

export default function useDebouncedValue<T>(value: T, ms = 100) {
  const [debouncedValue, setDebouncedValue] = React.useState(value);

  React.useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), ms);
    return () => clearTimeout(timeout);
  }, [value, ms]);

  return debouncedValue;
}
